import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { COMPARE_WITH, COMPARE_WITHOUT } from "../lib/data";
export function Compare() {
  return <section className="px-4 pt-12" data-id="element-42" data-mp="6kmhlfts4er">
      <div className="mx-auto max-w-md" data-id="element-43" data-mp="3iizdh14y3j71">
        <h2 className="text-center font-display text-xl font-extrabold text-slate-900" data-id="element-44" data-mp="3ihxwkg1902he">
          Es momento de que recuperes las horas que pierdes durante la semana
        </h2>

        <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-45" data-mp="38j8jd0kar67h">
          {/* Sin */}
          <div className="rounded-2xl border border-red-100 bg-red-50/70 p-3" data-id="element-46" data-mp="3djw6vc9bh4wy">
            <p className="mb-2 text-center text-[13px] font-extrabold text-red-600" data-id="element-47" data-mp="2zjlg0980bqbs">
              Sin megapack
            </p>
            <ul className="space-y-2" data-id="element-48" data-mp="34hwpgiue3yth">
              {COMPARE_WITHOUT.map((c, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-49" data-mp="xrp5n2xksmil" data-mpi={i}>
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" data-id="element-50" data-mp="xqe0ozse98pw" />
                  <span className="text-[11.5px] leading-tight text-slate-600" data-id="element-51" data-mp="12qjtijaeh19k">{c}</span>
                </li>)}
            </ul>
          </div>

          {/* Con */}
          <div className="rounded-2xl border-2 border-teal-300 bg-teal-50 p-3" data-id="element-52" data-mp="1zq2bs99v2m9j">
            <p className="mb-2 text-center text-[13px] font-extrabold text-teal-700" data-id="element-53" data-mp="2dii9cujzts32">
              Con megapack
            </p>
            <ul className="space-y-2" data-id="element-54" data-mp="28jp0jffnip98">
              {COMPARE_WITH.map((c, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-55" data-mp="1kucmo29dpt0l" data-mpi={i}>
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal-600" data-id="element-56" data-mp="1gshkkvjmjblr" />
                  <span className="text-[11.5px] font-medium leading-tight text-slate-700" data-id="element-57" data-mp="1urqxnmcj9pli">
                    {c}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}